import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["useEmbeddedGlobalNav"];
import { EmbeddedGlobalNav } from './EmbeddedGlobalNav';
import { LegacyMarketingNav } from './LegacyMarketingNav';
import { jsx as _jsx } from "react/jsx-runtime";
export function MarketingNav(_ref) {
  let {
      useEmbeddedGlobalNav = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return useEmbeddedGlobalNav ? /*#__PURE__*/_jsx(EmbeddedGlobalNav, Object.assign({}, rest)) : /*#__PURE__*/_jsx(LegacyMarketingNav, Object.assign({}, rest));
}